var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-select-menu-with-label max-w-full",
      class: _vm.selectStyle === "alternative" ? "w-auto" : "w-full",
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center",
          class: { "flex-col": _vm.selectStyle === "alternative" },
        },
        [
          _c(
            "div",
            {
              class: [
                _vm.infoHeading || _vm.infoText ? "" : "w-14",
                {
                  "flex justify-center items-center":
                    _vm.selectStyle === "alternative",
                },
              ],
            },
            [
              _c(
                "label",
                {
                  staticClass: "text-xxs font-semibold uppercase truncate",
                  class: {
                    "text-theme": _vm.themed,
                    "text-black": !_vm.themed,
                  },
                  attrs: { for: _vm.id },
                },
                [_vm._v(_vm._s(_vm.label))]
              ),
              _vm._v(" "),
              _vm.infoHeading || _vm.infoText
                ? _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      themed: "",
                      heading: _vm.infoHeading,
                      body: _vm.infoText,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "v-select-custom text-lg",
            class: {
              "v-select-custom--above": _vm.openAbove,
              "v-select-custom--themed": _vm.themed,
              "v-select-custom--alt": _vm.selectStyle === "alternative",
            },
            attrs: {
              id: _vm.id,
              "data-testid": _vm.testId,
              searchable: false,
              clearable: false,
              filterable: false,
              options: _vm.options,
              placeholder: _vm.placeholder,
              components: { OpenIndicator: _vm.OpenIndicator },
            },
            model: {
              value: _vm.selectOption,
              callback: function ($$v) {
                _vm.selectOption = $$v
              },
              expression: "selectOption",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }